import React, { Component } from 'react';
import styles from './Admin.module.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
class Admin extends Component {

    state = {
        users:[]
    }
    componentDidMount() {
        axios.get('/users.json')
        .then(response=>{
            axios.get('/newUsers.json')
            .then(res=>{
                const users = [];
                res.data.map(obj=>{
                    if(obj === '') return;
                    users.push({...obj,...response.data[obj.userId]})
                })
                this.setState({users:users})
            })
        })
    }
    getTimeStamp = (date) => {
        const _date = new Date(date);
        const milliseconds = new Date() - _date;
        const monts = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

        if((milliseconds/1000) < 60) return Math.floor(milliseconds/1000) + ' SECONDS AGO';
        else if((milliseconds/60000) < 60){
            const minutes = Math.floor(milliseconds/60000);
            return  minutes + (minutes > 1 ? ' MINUTES AGO' : ' MINUTE AGO');
        } 
        else if((milliseconds/3600000) <= 24) { 
            const hours = Math.floor(milliseconds/3600000);
            return hours + (hours > 1 ? ' HOURS AGO' : ' HOUR AGO');
        }
        else if((milliseconds/3600000/24) <= 7){
            const days = Math.floor(milliseconds/3600000/24);
            return days + (days > 1 ? ' DAYS AGO' : ' DAY AGO');
        } else {
            return _date.getDate() + ' ' + monts[_date.getMonth()] + ' '+_date.toLocaleTimeString();
        }
    }
    render(){
        return(
            <div className={styles.feed}>
            <section>
            <div className={styles.top}>
                <h4>New Users</h4>
               <div className={styles.suggestions}>
                   {
                    this.state.users.map(user => {
                        const userId = user.userId;
                    return(  
                        <div className={styles.user} key={userId}>
                            <div className={styles.dp}>
                             <Link to={'/account/' + userId} >
                              <img src={user.profilePic} 
                              width="50" height="50" alt={user.name + '\'s profile pic'} /> 
                              </Link>
                            </div>
                            <div className={styles.details}>
                            <Link to={'/account/' + userId} >
                             <div className={styles.name}>
                                <h2>{user.name}</h2>                                 
                            </div>
                            </Link>
                            <div className={styles.time}>
                                {this.getTimeStamp(user.time)}
                            </div>
                            </div>
                        </div>
                        )
                    })
                }
               </div>  
            </div>
            </section>
            
        </div>
        )
    }
}

export default Admin;